import Parse from "parse";

const normalizeConversation = (conversation) => ({
  id: conversation?.otherUser?.userId,
  userId: conversation?.otherUser?.userId,
  username: conversation?.otherUser?.username || "Unknown",
  role: conversation?.otherUser?.role || "Unknown",
  lastMessage: conversation?.lastMessage || "",
  lastMessageAt: conversation?.lastMessageAt || null,
  unread: conversation?.unreadCount || 0,
});

const normalizeMessage = (message, currentUserId) => ({
  id: message.id,
  senderId: message.senderId,
  text: message.message || "",
  message: message.message || "",
  createdAt: message.createdAt,
  isRead: message.isRead,
  isMe: message.senderId === currentUserId,
});

export const getUsersWithMessages = async () => {
  const conversations = (await Parse.Cloud.run("getConversations")) || [];
  return conversations.map(normalizeConversation);
};

export const getMessagingStatus = async () => {
  const result = await Parse.Cloud.run("getMessagingStatus");
  return result?.enabled === true;
};

export const getMessages = async (selectedUser) => {
  if (!selectedUser?.userId && !selectedUser?.id) {
    return [];
  }

  const recipientId = selectedUser.userId || selectedUser.id;
  const currentUserId = Parse.User.current()?.id;
  const messages =
    (await Parse.Cloud.run("getMessages", {
      recipientId,
      limit: 100,
      skip: 0,
    })) || [];

  return messages
    .slice()
    .reverse()
    .map((message) => normalizeMessage(message, currentUserId));
};

export const searchUsers = async (searchTerm, roleName = "") => {
  const users =
    (await Parse.Cloud.run("searchMessagableUsers", {
      searchTerm: searchTerm?.trim() || "",
      roleName: roleName || "",
    })) || [];

  return users
    .filter((user) => user.role !== "Player")
    .map((user) => ({
      id: user.userId,
      userId: user.userId,
      username: user.username,
      role: user.role,
      unread: 0,
      lastMessage: "",
      lastMessageAt: null,
    }));
};

export const getMessagableRoles = async () => {
  const roles = (await Parse.Cloud.run("getMessagableRoles")) || [];
  return roles.filter((role) => role !== "Player");
};

export const sendMsg = async (selectedUser, text) => {
  const recipientId = selectedUser?.userId || selectedUser?.id;
  if (!recipientId) return null;

  return Parse.Cloud.run("sendMessage", {
    recipientId,
    message: text,
  });
};

export const markRead = async (selectedUser) => {
  const recipientId = selectedUser?.userId || selectedUser?.id;
  if (!recipientId) return [];

  return Parse.Cloud.run("getMessages", {
    recipientId,
    limit: 100,
    skip: 0,
  });
};
